<div class="jobs">
  <nav class="flex">
    <div class="flex row">
      <a routerLink="active" routerLinkActive="active"> QUEUE </a>
      <a routerLink="history" routerLinkActive="active"> HISTORY </a>
      <a
        *ngIf="showPackagerTab"
        routerLink="packager"
        routerLinkActive="active"
      >
        PACKAGER
      </a>
    </div>
    <div class="flex row to-end">
      <a class="btn-cta" (click)="reloadCurrentRoute()">
        <span class="icon">↻</span> Refresh
      </a>
      <a class="btn-cta" routerLink="new" routerLinkActive="active">
        <span class="icon">+</span> Add Job
      </a>
    </div>
  </nav>

  <div class="inner-content">
    <router-outlet></router-outlet>
  </div>
</div>
